export default __webpack_public_path__ + "static/media/EricAtBeaujolais400.f67cc355.jpg";